import React from 'react'
import './SpinnerScaleout.scss'

// eslint-disable-next-line no-empty
const SpinnerScaleout = () => <div className="SpinnerScaleout" />

export {SpinnerScaleout}
